import { render, staticRenderFns } from "./OrdemServicoForm.vue?vue&type=template&id=3d224e48&scoped=true&"
import script from "./OrdemServicoForm.vue?vue&type=script&lang=js&"
export * from "./OrdemServicoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d224e48",
  null
  
)

export default component.exports